import { useMediaType } from '@packages/shared/src/hooks/useMediaType/useMediaType';
import type { ImageFileType, ImageType } from '../../../../interfaces/components';

export const useImageData = ({
  file: files,
  image_default,
  image_mobile,
}: {
  file?: ImageFileType[];
  image_default?: ImageType;
  image_mobile?: ImageType;
}): {
  imageData: ImageType | ImageFileType | null;
  isVectorImage: boolean;
  imageDataWidth: string | null;
  imageDataHeight: string | null;
} => {
  const isDesktop = useMediaType();
  const imageObjDefault =
    files?.find(
      (file) => file.field_name === 'field_image_default' || file.field_name === 'field_svg_file',
    ) ??
    image_default ??
    null;

  const imageObjMobile =
    files?.find((file) => file.field_name === 'field_image_mobile') ?? image_mobile ?? null;

  const imageData = !isDesktop && imageObjMobile ? imageObjMobile : imageObjDefault;
  const isVectorImage = !!files?.some((file) => file.filemime === 'image/svg+xml');
  const imageDataWidth = (!Array.isArray(imageData?.data) && imageData?.data?.width) || null;
  const imageDataHeight = (!Array.isArray(imageData?.data) && imageData?.data?.height) || null;

  return {
    imageData,
    isVectorImage,
    imageDataWidth,
    imageDataHeight,
  };
};
